export type Config = {
  /** Deployed environment (`dev`, `qa`, `sit`, `uat`). Set in `config/config.*.js`. */
  environment: string;
  BSYS_DXP_GQL: string;
  BSYS_DXP_API: string;
  oidc: {
    authority: string;
    client_id: string;
    scope?: string;
  };
  customerAssistant: {
    agentId: string;
    assistEnvironment: "stage" | "prod";
    productAgents: string[];
  };
  links: {
    profile: string;
    virtualWarehouse: string;
  };
  translations: {
    cdnEnabled: boolean;
    cdnBaseUrl: string;
    machinePreviewAllowed: boolean;
  };
  newrelic?: {
    applicationID: string;
    licenseKey: string;
    accountID: string;
    trustKey: string;
  };
};

declare global {
  interface Window {
    config: Config;
  }
}

const config: Config = window.config;
export default config;
